"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryKeyNotBusinessRule = void 0;
exports.isPrimaryKeyTechnical = isPrimaryKeyTechnical;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Primary Keys are the default unique way to get a single row in a table.
 * They are also often used on foreign keys to reference a single record.
 * Having a primary key on every table is a common best practice.
 */
const ruleId = 'primary-key-not-business';
const ruleName = 'business primary key forbidden';
const ruleDescription = 'entities with primary key which don\'t end with id or has a relation';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('PrimaryKeyNotBusinessConf');
exports.primaryKeyNotBusinessRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        const relations = (0, utils_1.groupBy)(db.relations || [], r => (0, databaseUtils_1.entityRefToId)(r.src));
        return (db.entities || [])
            .filter(e => !isPrimaryKeyTechnical(e, relations[(0, databaseUtils_1.entityToId)(e)] || []))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => {
            const { stats, extra, ...primaryKey } = e.pk || {};
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Entity ${(0, databaseUtils_1.entityToId)(e)} should have a technical primary key, current one is: (${e.pk?.attrs.map(databaseUtils_1.attributePathToId).join(', ')}).`,
                entity: (0, databaseUtils_1.entityToRef)(e),
                attribute: e.pk?.attrs?.[0],
                extra: { primaryKey }
            };
        });
    }
};
function isPrimaryKeyTechnical(entity, relations) {
    if ((entity.kind === undefined || entity.kind === 'table') && !!entity.pk) {
        // primary key attributes should either end with 'id' or have a relation, otherwise it's likely business
        return entity.pk.attrs.every(pkAttr => {
            const isAutoIncrement = false; // FIXME: compute this!
            const endsWithId = pkAttr.slice(-1)[0].toLowerCase().endsWith('id');
            const hasRelation = relations.find(r => r.src.attrs.find(a => (0, databaseUtils_1.attributePathToId)(a) === (0, databaseUtils_1.attributePathToId)(pkAttr)));
            return !isAutoIncrement && (endsWithId || hasRelation);
        });
    }
    else {
        return true; // not table or no primary key
    }
}
//# sourceMappingURL=primaryKeyNotBusiness.js.map